<template>
  <div class="steps">
    <span
      v-for="(step, index) in steps"
      :key="step.title"
      :class="[{ selected: step.selected }]"
      :style="getStepStyle(index)"
    >
    </span>
    <hr />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
  selectedSection: {
    type: Number,
    default: 1
  },
  stepsColor: {
    type: String,
    default: "#2effec"
  },
  background: {
    type: String,
    default: "#000000"
  },
  steps: {
    type: Array,
    default: undefined
  }
});
const backgroundColor = ref("");

onMounted(() => {
  backgroundColor.value = props.background || "#000000";
});
const getStepStyle = index => {
  const totalSteps = props.steps.length;
  const leftPercentage = (index / (totalSteps - 1)) * 100;
  return {
    left: `${leftPercentage}%`
  };
};
</script>
<style lang="scss" scoped>
.steps {
  position: relative;
  display: flex;
  align-items: center;
  span {
    width: 13px;
    height: 13px;
    position: absolute;
    border-radius: 100%;
    border-color: v-bind(stepsColor);
    border-width: 1px;
    background-color: v-bind(backgroundColor);
    &.selected {
      background-color: v-bind(stepsColor);
    }
  }
  hr {
    width: 280px;
    height: 1px;
    color: v-bind(stepsColor);
    @media screen and (min-width: $screen-md) {
      width: 364px;
    }
  }
}
</style>
